// Models
PJQ.models.actionItems.ActionItem = PJQ.models.BaseModel.extend({
    notifyName: 'Action Item',
    idAttribute: "actionItemId",
    endpoint: function () {
        let arr;
        if (this.get('projectId') > 0) {
            arr = [
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'actionitems',
                    value: this.id
                }
            ];
        } else if (this.isNew() && this.get('templateId') > 0) {
            arr = [
                {
                    endpoint: 'actionitems'
                },
                {
                    endpoint: 'templates',
                    value: this.get('templateId')
                },
                {
                    endpoint: 'item'
                }
            ];
        } else {
            arr = [
                {
                    endpoint: 'actionitems',
                    value: this.id
                }
            ];
        }

        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    afterInit: function () {
        if (this.get('customFieldValues') == null) {
            this.set('customFieldValues', [], {
                silent: true
            });
        }

        this.on('change:assignedTo', _.bind(function () {
            let assignedTo = this.get('assignedTo');
            if (assignedTo instanceof PJQ.models.projectContacts.ProjectContact) {
                this.assignedTo = this.get('assignedTo');
            } else if (assignedTo != null) {
                this.assignedTo = new PJQ.models.projectContacts.ProjectContact(this.get('assignedTo'));
            } else {
                this.assignedTo = null;
            }

            if (this.get('status') === PJQ.constants.actionItems.statuses.NEW || PJQ.constants.actionItems.statuses.NOT_RESOLVED) {
                this.ballInCourt = this.assignedTo;
                this.set('ballInCourt', this.ballInCourt);
            }
        }, this));
    },
    parse: function (model) {
        if (!model)
            return model;

        this.groups = new PJQ.collections.groups.Groups(model.groups);

        if (model.createdBy != null) {
            this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
        } else {
            this.createdBy = null;
        }

        if (model.assignedTo) {
            this.assignedTo = new PJQ.models.projectContacts.ProjectContact(model.assignedTo);
        } else {
            this.assignedTo = null;
        }

        if (_.size(model.distributionList) > 0) {
            this.distributionList = new PJQ.collections.projectContacts.ProjectContacts(model.distributionList);
        } else if (!this.distributionList) {
            this.distributionList = new PJQ.collections.projectContacts.ProjectContacts();
        }

        // if (model.workCompletedBy) {
        //     this.workCompletedBy = new PJQ.models.projectContacts.ProjectContact(model.workCompletedBy);
        // }
        // else{
        //     this.workCompletedBy = null;
        // }
        //
        // if (model.resolvedBy) {
        //     this.resolvedBy = new PJQ.models.projectContacts.ProjectContact(model.resolvedBy);
        // }
        // else{
        //     this.resolvedBy = null;
        // }

        if (_.size(model.comments) > 0) {
            this.comments = new PJQ.collections.actionItems.ActionItemComments(model.comments);
        } else {
            this.comments = new PJQ.collections.actionItems.ActionItemComments();
        }

        if (_.size(model.attachments) > 0) {
            this.attachments = new PJQ.collections.actionItems.ActionItemAttachments(model.attachments);
        } else {
            this.attachments = new PJQ.collections.actionItems.ActionItemAttachments();
        }

        if (_.size(model.beforeAttachments) > 0) {
            this.beforeAttachments = new PJQ.collections.actionItems.ActionItemAttachments(model.beforeAttachments);
        } else {
            this.beforeAttachments = new PJQ.collections.actionItems.ActionItemAttachments();
        }

        if (_.size(model.afterAttachments) > 0) {
            this.afterAttachments = new PJQ.collections.actionItems.ActionItemAttachments(model.afterAttachments);
        } else {
            this.afterAttachments = new PJQ.collections.actionItems.ActionItemAttachments();
        }

        return model;
    },
    getDeepLink: function () {
        let projectId = this.get('projectId');
        if (!(this.id > 0) || !(projectId > 0)) {
            return null;
        }
        return '#projects/' + projectId.toString() + '/actionitems/' + this.id.toString();
    },
    getStatusColor: function () {
        if (this.get('status') == null) {
            this.set('status', PJQ.constants.actionItems.statuses.NEW);
        }

        if (this.assignedTo != null && this.get('status') === PJQ.constants.actionItems.statuses.NEW) {
            return PJQ.constants.actionItems.statusColors[PJQ.constants.actionItems.statuses.ASSIGNED];
        }
        return PJQ.constants.actionItems.statusColors[this.get('status')];
    },
    getStatusName: function () {
        if (this.get('status') == null) {
            this.set('status', PJQ.constants.actionItems.statuses.NEW);
        }

        if (this.assignedTo != null && this.get('status') === PJQ.constants.actionItems.statuses.NEW) {
            return PJQ.constants.actionItems.statusNames[PJQ.constants.actionItems.statuses.ASSIGNED];
        } else if (this.get('status') === PJQ.constants.actionItems.statuses.WORK_COMPLETED) {
            let workCompletedOverride = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.ACTION_ITEM_WORK_COMPLETED_STATUS_OVERRIDE);
            if (workCompletedOverride != null) {
                return workCompletedOverride;
            }
        }
        return PJQ.constants.actionItems.statusNames[this.get('status')];
    },
    getPriorityColor: function () {
        if (this.get('priority') == null) {
            this.set('priority', PJQ.constants.actionItems.priorities.LOW);
        }
        return PJQ.constants.actionItems.priorityColors[this.get('priority')];
    },
    getPriorityName: function () {
        if (this.get('priority') == null) {
            this.set('priority', PJQ.constants.actionItems.priorities.LOW);
        }
        return PJQ.constants.actionItems.priorityNames[this.get('priority')];
    },
    beforeSave: function () {
        this.set({
            groups: this.groups.toJSON(),
            assignedTo: this.assignedTo?.toJSON(),
            distributionList: this.distributionList.toJSON(),
            attachments: this.attachments.getChangedModels(),
            beforeAttachments: this.beforeAttachments.getChangedModels(),
            afterAttachments: this.afterAttachments.getChangedModels(),
            comments: this.comments.getChangedModels()
        });
    },
    fetchNotifications: function (callback) {
        if (this.notifications == null) {
            this.notifications = new PJQ.collections.actionItems.Notifications(null, {
                actionItem: this
            })
        }

        this.notifications.fetch({
            success: _.bind(function () {
                callback(this.notifications);
            }, this)
        });
    },
    distribute: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/distribute',
        }).post().done((response) => {
            this.reset(response);
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((res) => {
            let err = null;
            if (res.responseJSON && res.responseJSON.message) {
                err = res.responseJSON.message;
            }
            if (typeof callback === 'function') {
                callback(false, err);
            }
        });
    },
});

PJQ.models.actionItems.ActionItemComment = PJQ.models.BaseModel.extend({
    idAttribute: "commentId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'actionitems',
                value: this.get('actionItemId')
            },
            {
                endpoint: 'comments',
                value: this.get('commentId')
            }
        ])
    },
    parse: function (model) {
        if (!model) {
            return model;
        }

        if (model.createdBy != null) {
            this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
        }

        return model;
    }
});

PJQ.models.actionItems.EditHistoryItem = PJQ.models.BaseModel.extend({
    parse: function (model) {
        if (!model)
            return model;

        this.createdOnDisplay = PJQ.helpers.dateHelpers.getDateString(new Date(model.createdOn), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);

        this.createdByDisplay = '';

        if (model.createdBy && model.createdBy.companyName)
            this.createdByDisplay = model.createdBy.contactName + ' (' + model.createdBy.companyName + ')';

        this.oldValueDisplay = model.oldValue;
        this.newValueDisplay = model.newValue;

        if (model.fieldType === 'DATE') {
            if (model.oldValue)
                this.oldValueDisplay = PJQ.helpers.dateHelpers.getDateString(new Date(model.oldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
            if (model.newValue)
                this.newValueDisplay = PJQ.helpers.dateHelpers.getDateString(new Date(model.newValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
        } else if (model.fieldType === 'DATETIME') {
            if (model.oldValue)
                this.oldValueDisplay = PJQ.helpers.dateHelpers.getDateString(new Date(model.oldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
            if (model.newValue)
                this.newValueDisplay = PJQ.helpers.dateHelpers.getDateString(new Date(model.newValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
        }

        return model;
    }
});

PJQ.models.actionItems.ActionItemAttachment = PJQ.models.files.File.extend({
    idAttribute: 'attachmentId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'actionitems',
                value: this.get('actionItemId')
            },
            {
                endpoint: 'attachments',
                value: this.id
            }
        ]);
    }
});

PJQ.models.actionItems.ActionItemCustomField = PJQ.models.customFields.CustomField.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'actionitems'
            },
            {
                endpoint: 'customFields',
                value: this.id
            }
        ])
    }
});

PJQ.models.actionItems.Notification = PJQ.models.notifications.Notification.extend({
    notificationTypeNames: PJQ.constants.actionItems.notificationTypeNames,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'actionitems',
                value: this.collection.options.actionItem.id
            },
            {
                endpoint: 'notifications',
                value: this.id
            }
        ])
    }
});

PJQ.models.actionItems.Settings = PJQ.models.BaseModel.extend({
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('project').id
            },
            {
                endpoint: 'actionitems'
            },
            {
                endpoint: 'settings'
            }
        ])
    },
    parse: function (model) {
        if (!model)
            return model;

        this.projectContacts = new PJQ.collections.actionItems.ProjectContactSettings(model.projectContacts);
        _.each(this.projectContacts.models, _.bind(function (setting) {
            let matchProjectContact = PJQ.app.session.project.projectContacts.findWhere({id: setting.get('id')});
            if (matchProjectContact != null) {
                setting.set(matchProjectContact.attributes, {
                    isSilent: true
                });
            }
        }, this));

        return model;
    },
    beforeSave: function () {
        this.set('projectContacts', this.projectContacts.filter(function (projectContact) {
            return projectContact.hasChanged();
        }));
    }
});

PJQ.models.actionItems.ActionItemUserSettings = PJQ.models.BaseModel.extend({
    endpoint: function () {
        let params = [];
        if (this.options.forCompany) {
            params.push({
                parameter: 'forCompany',
                value: true
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'actionitems'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ], params);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});


PJQ.models.actionItems.ProjectContactSetting = PJQ.models.BaseModel.extend({});

PJQ.models.actionItems.Template = PJQ.models.BaseModel.extend({
    idAttribute: 'templateId',
    notifyName: 'Template',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'actionitems'
            },
            {
                endpoint: 'templates',
                value: this.id
            }
        ], this.get('projectId') > 0 ? [
            {
                parameter: 'projectId',
                value: this.get('projectId')
            },
            {
                parameter: 'copyComments',
                value: this.get('copyComments')
            },
            {
                parameter: 'copyAssignee',
                value: this.get('copyAssignee')
            },
            {
                parameter: 'copyGroups',
                value: this.get('copyGroups')
            },
            {
                parameter: 'overwrite',
                value: this.get('overwrite')
            }
        ] : null);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.project != null) {
            this.project = model.project;
        } else {
            this.user = PJQ.app.session.user;
        }

        this.groups = new PJQ.collections.groups.Groups(model.groups);

        if (model.createdBy != null) {
            this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
        } else {
            this.createdBy = null;
        }

        if (model.assignee != null) {
            this.assignee = new PJQ.models.projectContacts.ProjectContact(model.assignee);
        } else {
            this.submitter = null;
        }

        this.comments = new PJQ.collections.actionItems.ActionItemComments(model.comments);

        this.attachments = new PJQ.collections.actionItems.ActionItemAttachments(model.attachments);

        if (model.actionItems)
            this.actionItems = new PJQ.collections.actionItems.ActionItems(model.actionItems);
        else if (model.items)
            this.actionItems = new PJQ.collections.actionItems.ActionItems(model.items);
        else
            this.actionItems = new PJQ.collections.actionItems.ActionItems();

        return model;
    }
});


// Collections
PJQ.collections.actionItems.ActionItems = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.actionItems.ActionItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'actionitems'
            }
        ])
    }
});

PJQ.collections.actionItems.Notifications = PJQ.collections.notifications.Notifications.extend({
    model: PJQ.models.actionItems.Notification,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'actionitems',
                value: this.options.actionItem.id
            },
            {
                endpoint: 'notifications'
            }
        ])
    }
});

PJQ.collections.actionItems.EditHistoryItems = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.actionItems.EditHistoryItem
});

PJQ.collections.actionItems.ActionItemComments = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.actionItems.ActionItemComment
});

PJQ.collections.actionItems.ActionItemAttachments = PJQ.collections.files.Files.extend({
    model: PJQ.models.actionItems.ActionItemAttachment
});

PJQ.collections.actionItems.ProjectContactSettings = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.actionItems.ProjectContactSetting
});

PJQ.collections.actionItems.ActionItemCustomFields = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.actionItems.ActionItemCustomField,
    options: {
        masterUserId: null
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project ? this.options.project.id : null
                },
                {
                    endpoint: 'actionitems'
                },
                {
                    endpoint: 'customFields'
                }
            ],
            [
                {
                    parameter: 'masterUserId',
                    value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
                }
            ]);
    }
});

PJQ.collections.actionItems.ActionItemCustomField = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.actionItems.ActionItemCustomField,
    options: {
        masterUserId: null
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'actionitems'
                },
                {
                    endpoint: 'customFields'
                }
            ],
            [
                {
                    parameter: 'masterUserId',
                    value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
                }
            ]);
    }
});

PJQ.collections.actionItems.Templates = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.actionItems.Template,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'actionitems'
            },
            {
                endpoint: 'templates'
            }
        ]);
    }
});
